import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TabNavi extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.onClick(e);
  }

  render() {
    const dataAttrs = _.pickBy(this.props, (val, prop) => /data-.*/.test(prop));
    return (
      <li className="tab-navigation-nav-item">
        <a
          tabIndex={0}
          className={`tab-navigation-nav-link ${this.props.isCurrent ? 'current' : ''}`}
          onClick={this.handleClick}
          {...dataAttrs}
        >
          {this.props.name}
        </a>
      </li>
    );
  }
}

TabNavi.propTypes = {
  onClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  isCurrent: PropTypes.bool,
};
